import { render, staticRenderFns } from "./TableFolderCell.vue?vue&type=template&id=45907570&"
import script from "./TableFolderCell.vue?vue&type=script&lang=js&"
export * from "./TableFolderCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports